<div class="grid">
  <div class="col-12">
    <label for="">{{ "COMMON.METADATA.NAME" | translate }}</label>
    <input pInputText pSize="small" [(ngModel)]="metadata.name" fluid />
  </div>

  <div class="col-12 mt-2">
    <div
      class="grid mt-2"
      *ngFor="let option of this.metadata.options; index as _index"
    >
      <div class="col-12 sm:col-1 sm:mt-4">
        <button
          pButton
          [icon]="'fa fa-trash'"
          class="virtualcenter-button virtualcenter-button--danger"
          size="small"
          (click)="this.delete(_index)"
        ></button>
      </div>
      <div class="col-12 sm:col-6">
        <div class="field">
          <label>{{ "COMMON.METADATA.OPTIONS.OPTION.NAME" | translate }}</label>
          <input pInputText pSize="small" [(ngModel)]="option.name" fluid="" />
        </div>
      </div>
      <div class="col-12 sm:col-4 sm:mt-5">
        <div class="flex items-center">
          <p-radioButton
            name="optionDefault"
            [value]="option"
            [(ngModel)]="defaultOption"
          />
          <label for="">
            {{ "COMMON.METADATA.OPTIONS.DEFAULT" | translate }}
          </label>
        </div>
      </div>
    </div>
  </div>

  <div class="col-12">
    <div class="flex gap-2">
      <button
        pButton
        icon="fas fa-plus"
        label="{{ 'COMMON.METADATA.OPTION.ADD' | translate }}"
        class="virtualcenter-button virtualcenter-button--primary"
        size="small"
        (click)="this.addOption()"
      ></button>
      <button
        pButton
        label="{{ 'COMMON.SAVE' | translate }}"
        (click)="this.save()"
        icon="fas fa-save"
        *ngIf="this.metadata.options.length"
        size="small"
        class="virtualcenter-button virtualcenter-button--primary"
      ></button>
    </div>
  </div>
</div>
